export enum PaymentCardTypes {
    VISA = 'VISA',
    MASTER = 'MASTER',
    AMEX = 'AMEX',
    MAESTRO = 'MAESTRO',
    DINERS = 'DINERS',
    JCB = 'JCB',
    MASTER_WORLDPAY = "ECMC",
    DISCOVER = "DISCOVER",
    MASTERCARD = "MASTERCARD"
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/payment-card-types.enum.ts